import { connect } from "react-redux";
const OwlShopActions = require("lib/actions/OwlShopActions");
const OwlShopSelectors = require("lib/selectors/OwlShopSelectors");

require("games/FurnitureDisplay.scss");
var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var CurrentUser = require("lib/account/CurrentUser");
var ReactTooltip = require("react-tooltip");

var CSSTransition = require("react-transition-group/CSSTransition");
var TransitionGroup = require("react-transition-group/TransitionGroup");

@connect(
	(state, ownProps) => ({
		filteredPatches: OwlShopSelectors.getFilteredPatches({ state }),
		filteredPerks: OwlShopSelectors.getFilteredPerks({ state }),
		allFurnitures: OwlShopSelectors.getFurnitures({ state }),
		getPatchesByNameAndType: ({ name, originType }) =>
			OwlShopSelectors.getPatchesByNameAndType({ state, name, originType }),
		getPerksByNameAndType: ({ name, type }) =>
			OwlShopSelectors.getPerksByNameAndType({ state, name, type }),
	}),
	(dispatch, props) => ({
		updateFurnitures: ({ ids, newProperties }) =>
			dispatch(OwlShopActions.updateFurnitures({ ids, newProperties })),
		postFurnitures: ({ furniture, newProperties, callback }) =>
			dispatch(OwlShopActions.postFurnitures({ furniture, newProperties, callback })),
		updateCurrentUser: (callback) => CurrentUser.fetchCurrentUserCoinData(callback),
	}),
)
class FurnitureDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.previewItemRef = React.createRef();

		this.state = {
			editStyle: { top: 0, left: 0 },
			buyLoading: false,
		};
	}

	// previews furniture (when redirected from golden egg modal)
	componentDidMount() {
		if (this.props.previewItemName && this.props.previewItemType) {
			this.setNewStyle(this.props.previewItemType)
		}

	}

	resetEditMode() {
		this.props.setPreviewItem(null, null);
	}

	getPerkPath(name, type) {
		var adjustedFurnitureType = this.getAdjustedFurnitureType(type);
		var perkPath = "furnitures/" + adjustedFurnitureType + "/" + name + ".png";
		return dynamicRequire(perkPath);
	}

	renderPreviewItem() {
		var perkPath = this.getPerkPath(this.props.previewItemName, this.props.previewItemType);
		var previewStyle = {
			top: this.state.editStyle.top + "%",
			left: this.state.editStyle.left + "%",
		};
		return (
			<img
				ref={this.previewItemRef}
				className={"furnitureItem " + this.props.previewItemType}
				style={previewStyle}
				src={perkPath}
			/>
		);
	}
	renderFurnitures() {
		var images = [];
		var opacity = 1.0;
		if (this.props.previewItemType) {
			opacity = 0.5;
		}
		if (this.props.furnitures) {
			_.each(this.props.furnitures, (furnitures, furniture_type) => {
				if (furniture_type != this.props.previewItemType) {
					_.each(furnitures, (data, furniture) => {
						if (data.equipped) {
							var perkPath = this.getPerkPath(furniture, furniture_type);
							var furnitureStyle = {
								top: data.style.top + "%",
								left: data.style.left + "%",
								opacity: opacity,
							};
							images.push(
								<img
									key={furniture_type + "_" + furniture}
									className={"furnitureItem " + furniture_type}
									style={furnitureStyle}
									src={perkPath}
								/>,
							);
						}
					});
				}
			});
		}
		return images;
	}
	onFurnitureClick(furniture, furniture_type) {
		if (this.props.editMode) {
			this.props.setPreviewItem(furniture, furniture_type);
		}
	}
	moveObject(direction) {
		var newStyle = _.clone(this.state.editStyle);

		switch (direction) {
			case "up":
				newStyle.top -= constants.INCREMENT;
				break;
			case "down":
				newStyle.top += constants.INCREMENT;
				break;
			case "left":
				newStyle.left -= constants.INCREMENT;
				break;
			case "right":
				newStyle.left += constants.INCREMENT;
				break;
		}
		if (this.isFurnitureWithinBounds(newStyle)) {
			this.setState({ editStyle: newStyle });
		}
	}
	isFurnitureWithinBounds(newStyle) {
		var size = this.getFurnitureSize();

		var upperBound = 5;
		var lowerBound = 95;
		if (_.include(["wall_items", "wall_items2"], this.props.previewItemType)) {
			lowerBound = 76;
			if (newStyle.top + size.h > 76 || newStyle.left + size.w > 95) {
				return false;
			}
		} else if (_.include(["floor_items", "floor_items2"], this.props.previewItemType)) {
			if (
				newStyle.top + size.h > 90 ||
				newStyle.top + size.h < 84 ||
				newStyle.left + size.w > 95
			) {
				return false;
			}
		} else {
			if (newStyle.top + size.h > 95 || newStyle.left + size.w > 95) {
				return false;
			}
		}

		if (newStyle.top < 5 || newStyle.left < 5) {
			return false;
		}
		return true;
	}

	renderEditOptions() {
		if (
			_.include(
				["wall_items", "wall_items2", "floor_items", "floor_items2"],
				this.props.previewItemType,
			)
		) {
			var upOption = (
				<a
					className="up-arrow arrow"
					data-tip={"Move furniture up"}
					onClick={this.moveObject.bind(this, "up")}
				>
					<Glyphicon icon="circle-arrow-up" />
				</a>
			);
			var downOption = (
				<a
					className="down-arrow arrow"
					data-tip={"Move furniture down"}
					onClick={this.moveObject.bind(this, "down")}
				>
					<Glyphicon icon="circle-arrow-down" />
				</a>
			);
		}
		if (this.isFurnitureOwned()) {
			var purchaseText = "Save";
		} else {
			var purchaseText = "Buy it";
		}
		if (this.isFurnitureTypeEquipped()) {
			var removeAction = (
				<a className="remove" onClick={this.removeFurniture}>
					Remove
				</a>
			);
		}
		return (
			<div className="editOptions">
				<a
					className="left-arrow arrow"
					data-tip={"Move left"}
					onClick={this.moveObject.bind(this, "left")}
				>
					<Glyphicon icon="circle-arrow-left" />
				</a>
				<a
					className="right-arrow arrow"
					data-tip={"Move right"}
					onClick={this.moveObject.bind(this, "right")}
				>
					<Glyphicon icon="circle-arrow-right" />
				</a>
				{upOption}
				{downOption}
				<div className="shopActions backgroundPatcher">
					<button className="btn btn-default" onClick={this.resetEditMode}>
						Cancel
					</button>
					<LoadingButton
						className="btn buttonSuccess purchase"
						loading={this.state.buyLoading}
						onClick={this.purchaseFurniture}
						text={purchaseText}
					/>
					{removeAction}
				</div>
				<ReactTooltip effect="solid" />
			</div>
		);
	}

	// componentWillReceiveProps(nextProps) {
	// 	if (nextProps.previewItemName != this.props.previewItemName) {
	// 		this.setNewStyle(nextProps.previewItemType)
	// 	}
	// }
	componentDidUpdate(prevProps) {
		if (this.props.previewItemName && prevProps.previewItemName != this.props.previewItemName) {
			this.setNewStyle(this.props.previewItemType);
		}
	}
	getFurnitureSize() {
		var width = null;
		var height = null;
		const previewItem = this.previewItemRef.current;
		if (previewItem) {
			var backgroundImage = $(this.refs.wrap)
				.closest(".houseInteriorRoom")
				.find(".backgroundImage");
			var backgroundWidth = backgroundImage.width();
			var backgroundHeight = backgroundImage.height();

			width = (previewItem.width / parseFloat(backgroundWidth)) * 100;
			height = (previewItem.height / parseFloat(backgroundHeight)) * 100;
		}
		return { w: width, h: height };
	}

	setNewStyle(furnitureType) {
		var adjustedFurnitureType = this.getAdjustedFurnitureType(furnitureType);
		var size = this.getFurnitureSize();
		var initialPlacement = constants.INITIAL_PLACEMENT[adjustedFurnitureType];
		var newTop = initialPlacement.top - size.h;
		var newLeft = initialPlacement.left - size.w;

		if (newTop != initialPlacement.top && newLeft != initialPlacement.left) {
			var style = { top: newTop, left: newLeft };
			this.setState({ editStyle: style });
		} else {
			setTimeout(this.setNewStyle.bind(this, furnitureType), 50);
		}
	}
	getAdjustedFurnitureType(furnitureType) {
		if (furnitureType == "wall_items2") {
			return "wall_items";
		} else if (furnitureType == "floor_items2") {
			return "floor_items";
		}
		return furnitureType;
	}
	render() {
		if (this.props.editMode) {
			var editOptions = this.renderEditOptions();
		}
		if (this.props.previewItemType) {
			var previewItem = (
				<CSSTransition classNames="appear" timeout={{ enter: 300, exit: 300 }}>
					{this.renderPreviewItem()}
				</CSSTransition>
			);
		}
		return (
			<div className="FurnitureDisplay" ref="wrap">
				<TransitionGroup>{previewItem}</TransitionGroup>
				{this.renderFurnitures()}
				{editOptions}
				<ReactTooltip effect="solid" />
			</div>
		);
	}
	isFurnitureOwned() {
		if (
			this.props.previewItemType == "wall_items" ||
			this.props.previewItemType == "wall_items2"
		) {
			return (
				(this.props.furnitures["wall_items"] &&
					this.props.furnitures["wall_items"][this.props.previewItemName]) ||
				(this.props.furnitures["wall_items2"] &&
					this.props.furnitures["wall_items2"][this.props.previewItemName])
			);
		} else if (
			this.props.previewItemType == "floor_items" ||
			this.props.previewItemType == "floor_items2"
		) {
			return (
				(this.props.furnitures["floor_items"] &&
					this.props.furnitures["floor_items"][this.props.previewItemName]) ||
				(this.props.furnitures["floor_items2"] &&
					this.props.furnitures["floor_items2"][this.props.previewItemName])
			);
		}
		return (
			this.props.furnitures[this.props.previewItemType] &&
			this.props.furnitures[this.props.previewItemType][this.props.previewItemName]
		);
	}
	isFurnitureTypeEquipped() {
		if (this.props.furnitures[this.props.previewItemType] == undefined) {
			return false;
		}
		var equipped = _.map(
			this.props.furnitures[this.props.previewItemType],
			(furniture, name) => {
				return furniture.equipped;
			},
		);
		return equipped.indexOf(true) > -1;
	}

	notifyErrors = errors =>
		window.wrNotifications.triggerDropDownNotification({
			title: "Sorry!",
			text: errors.join(", "),
			icon: "exclamation-sign",
			type: "error",
		});

	updateLocalFurnitureList = ({ furniture, newProperties }) =>
		this.props.updateFurnitures({
			ids: [furniture.id],
			newProperties,
		});

	handleFurniturePostResponse = furniture => response => {
		const { perk } = response;

		if (perk.errors) {
			this.notifyErrors(perk.errors);
			this.setState({
				buyLoading: false,
			});
		} else {
			if (this.isFurnitureOwned()) {
				var text = "Your furniture has been saved!";
			} else {
				var text = "You bought " + furniture.title + "!";
			}
			window.wrNotifications.triggerDropDownNotification({
				title: "Looking good!",
				text: text,
				icon: "ok-sign",
			});

			furniture["owned"] = true;
			furniture["equipped"] = true;
			this.props.equipFurniture(furniture);

			this.setState({ buyLoading: false });

			this.props.updateCurrentUser(() =>
				this.updateLocalFurnitureList({ furniture, newProperties: furniture }),
			);

			Mycroft.newEvent({
				category: "Owl Shop",
				action: "buy-item",
				label: furniture.title,
			});
		}
	};

	handleFurnitureRemoveResponse = furniture => response => {
		const { perk } = response;

		if (perk.errors) {
			this.notifyErrors(perk.errors);
			this.setState({
				buyLoading: false,
			});
		} else {
			if (this.props.previewItemType == constants.SOFAS) {
				var title = "Sofa removed";
				var text = "Poof! your sofa has vanished!";
			} else if (this.props.previewItemType == constants.BOOKSHELVES) {
				var title = "Bookshelf removed";
				var text = "Poof! your bookshelf have vanished!";
			} else if (
				this.props.previewItemType == constants.WALL_ITEM ||
				this.props.previewItemType == "wall_items2"
			) {
				var title = "Wall item removed";
				var text = "Poof! your wall item has vanished!";
			} else if (
				this.props.previewItemType == constants.FLOOR_ITEM ||
				this.props.previewItemType == "floor_items2"
			) {
				var title = "Floor item removed";
				var text = "Poof! your floor item has vanished!";
			}

			window.wrNotifications.triggerDropDownNotification({
				title: title,
				text: text,
				icon: "ok-sign",
			});

			this.props.equipFurniture(furniture);
		}
	}

	purchaseFurniture() {
		this.setState({ buyLoading: true });

		var furniture = {};
		furniture["name"] = this.props.previewItemName;
		furniture["title"] = this.props.previewItemTitle;
		furniture["furniture_type"] = this.props.previewItemType;
		furniture["origin_furniture_type"] = this.getAdjustedFurnitureType(
			this.props.previewItemType,
		);
		furniture["style"] = this.state.editStyle;

		furniture.id = `${furniture.furniture_type}-${furniture.name}`;

		this.props.postFurnitures({
			furniture,
			newProperties: null,
			callback: this.handleFurniturePostResponse(furniture),
		});
	}

	removeFurniture() {
		var blankItem = {};
		blankItem["furniture_type"] = this.props.previewItemType;
		blankItem["origin_furniture_type"] = this.getAdjustedFurnitureType(
			this.props.previewItemType,
		);

		this.props.postFurnitures({
			furniture: blankItem,
			newProperties: null,
			callback: this.handleFurnitureRemoveResponse(blankItem),
		});
	}
}

const constants = {};
constants.INCREMENT = 2;

constants.SOFAS = "sofas";
constants.BOOKSHELVES = "bookshelves";
constants.WALL_ITEM = "wall_items";
constants.FLOOR_ITEM = "floor_items";

constants.INITIAL_PLACEMENT = {
	sofas: { top: 83, left: 75 },
	bookshelves: { top: 80, left: 30 },
	wall_items: { top: 45, left: 70 },
	floor_items: { top: 90, left: 40 },
};

module.exports = FurnitureDisplay;



// WEBPACK FOOTER //
// ./modules/components/games/FurnitureDisplay.js